import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./select-faction-dialog.css";
import { toast } from "react-toastify";
import {Factions} from "../../../data/faction.enum";

export default function SelectFactionDialog({ selectedFaction, onCancel, onConfirm }) {
    const [selected, setSelected] = useState(selectedFaction || null);

    function handleSelect(faction) {
        setSelected(faction);
    }

    function handleConfirm() {
        if (!selected) {
            toast.error("Choose a faction");
            return;
        }
        onConfirm(selected);
    }

    function handleCancel() {
        if (!selected) {
            toast.error("Choose a faction");
            return;
        }
        onCancel();
    }

    return ReactDOM.createPortal(
        <div className="dialog-overlay" onClick={handleCancel}>
            <div id="dialog-container" onClick={(e) => e.stopPropagation()}>
                <div id="dialog-title">Choose Faction</div>
                <div id="faction-container">
                    <div
                        className={`faction-card ${selected === Factions.ALLIES ? "selected" : ""}`}
                        onClick={() => handleSelect(Factions.ALLIES)}
                    >
                        <img src="/img/factions/allies.jpg" alt="Allies" className="faction-icon"/>
                        <span>ALLIES</span>
                    </div>
                    <div
                        className={`faction-card ${selected === Factions.AXIS ? "selected" : ""}`}
                        onClick={() => handleSelect(Factions.AXIS)}
                    >
                        <img src="/img/factions/axis.jpg" alt="Axis" className="faction-icon"/>
                        <span>AXIS</span>
                    </div>
                </div>
                <div id="dialog-buttons">
                    {selectedFaction != null &&
                        <button onClick={handleCancel}>Cancel</button>
                    }
                    <button onClick={handleConfirm}>Confirm</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
